import _objectWithoutProperties from 'babel-runtime/helpers/objectWithoutProperties';
import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Header as StandaloneHeader } from '@sitebase/web-shell-kit/es/header';

import makeFeatureRenderer from '@sitebase/make-feature-renderer';
import makeFeatureRendererInPortal from './makeFeatureRendererInPortal';
import './Header.scss';

var assignSlot = function assignSlot(feature, slot) {
  return feature ? React.cloneElement(feature, { slot: slot }) : null;
};

var configNodeChildrenType = PropTypes.arrayOf(PropTypes.object);
if (process.env.NODE_ENV !== 'production') {
  configNodeChildrenType = PropTypes.arrayOf(function () {
    return configNodeType.apply(undefined, arguments);
  }); // lazy recursive call
}

var configNodeType = PropTypes.shape({
  type: PropTypes.string.isRequired,
  data: PropTypes.object,
  children: configNodeChildrenType
});

var Header = function (_PureComponent) {
  _inherits(Header, _PureComponent);

  function Header() {
    _classCallCheck(this, Header);

    return _possibleConstructorReturn(this, (Header.__proto__ || _Object$getPrototypeOf(Header)).apply(this, arguments));
  }

  _createClass(Header, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          config = _props.config,
          renderers = _props.renderers,
          restProps = _objectWithoutProperties(_props, ['config', 'renderers']);

      var renderFeature = makeFeatureRenderer(renderers);

      // @FIXME quickfix for https://jira.willhillatlas.com/browse/SBKS-2383.
      var renderToPortal = makeFeatureRendererInPortal(renderers);

      return React.createElement(
        'div',
        { 'data-test-id': 'pre-integrated-header', className: 'sb-pre-integrated-header' },
        renderToPortal(config.actions),
        React.createElement(
          StandaloneHeader,
          restProps,
          assignSlot(renderFeature(config.logo), 'logo'),
          assignSlot(renderFeature(config.productNav), 'product-nav'),
          assignSlot(renderFeature(config.actions), 'actions'),
          assignSlot(renderFeature(config.search), 'search'),
          assignSlot(renderFeature(config.subNavStart), 'sub-nav-start'),
          assignSlot(renderFeature(config.subNavEnd), 'sub-nav-end'),
          assignSlot(renderFeature(config.info), 'info')
        )
      );
    }
  }]);

  return Header;
}(PureComponent);

Header.propTypes = {
  config: PropTypes.shape({
    logo: configNodeType,
    productNav: configNodeType,
    actions: configNodeType,
    search: configNodeType,
    subNavStart: configNodeType,
    subNavEnd: configNodeType,
    info: configNodeType
  }),
  renderers: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.string.isRequired,
    render: PropTypes.func, // @FIXME quickfix for https://jira.willhillatlas.com/browse/SBKS-2383. Should be reverted to `.isRequired`
    renderToPortal: PropTypes.func // @FIXME quickfix for https://jira.willhillatlas.com/browse/SBKS-2383. Should be removed
  }))
};
Header.defaultProps = {
  config: {},
  renderers: []
};
export default Header;
//# sourceMappingURL=Header.js.map